module.exports = __webpack_public_path__ + "komu_banki_dayut_ipoteku.0b12fc2c41bb288d27ed343517ba823d.jpg";